import { propertyFieldLabel } from '../field-labels';

const labels: Record<string, string> = {
  status: 'Status',
  description: 'Description',
  corrective_action: 'Corrective action',
  response_due_date: 'Response due date',
  due_date: 'Due date',
  closed_at: 'Closed date',
  opened_at: 'Opened date',
  updated_at: 'Last source update',
  violation_date: 'Violation date',
  inspection_number: 'Inspection number',
  document_number: 'Document number',
  document_date: 'Document date',
};

/** Raw paths remain canonical; this dictionary is presentation-only. */
/** The last segment of a fact path; a dot inside a city label ("Tent. Approval", "No.") is not a separator. */
export function fieldPathTail(path: string) {
  return (path.split(/\.(?=[A-Za-z_[])/).at(-1) ?? path).replace(/\[.*$/, '');
}

export function issueFieldLabel(path: string) {
  const raw = fieldPathTail(path);
  if (labels[raw]) return labels[raw];
  // Source headings and compressed city keys read as plain words; the raw key stays in evidence.
  return propertyFieldLabel(raw);
}
